import { Switch } from '../ui/switch';
import { Slider } from '../ui/slider';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import {
  normalizeStoredValue,
  getNumericRange,
  resolveSchemaForType,
  resolveValuePresentation,
} from '../../utils/periodizationValueSchema';
import AttributeValueBadge from './AttributeValueBadge';

const AttributeValueEditor = ({ type, value, onChange }) => {
  const schema = resolveSchemaForType(type);
  const cfg = schema.config;

  if (cfg?.storage === 'boolean') {
    return (
      <div className='flex items-center gap-2'>
        <Switch checked={!!value} onCheckedChange={(v) => onChange(v)} />
        <AttributeValueBadge value={!!value} type={type} compact />
      </div>
    );
  }

  if (cfg?.storage === 'lookup_key') {
    const options = cfg.lookup?.options || [];
    return (
      <Select value={value != null ? String(value) : ''} onValueChange={(v) => onChange(v)}>
        <SelectTrigger className='h-8 text-xs'>
          <SelectValue placeholder='—' />
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt.key} value={opt.key}>
              <span className='flex items-center gap-2'>
                <span className='h-2 w-2 rounded-full' style={{ backgroundColor: opt.color }} />
                {opt.label}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  const range = getNumericRange(type);
  const n = normalizeStoredValue(value, type);
  return (
    <div className='space-y-1'>
      <Slider
        min={range.min}
        max={range.max}
        step={range.step || 1}
        value={[n]}
        onValueChange={([v]) => onChange(normalizeStoredValue(v, type))}
      />
      <div className='flex justify-between items-center'>
        <span className='text-[10px] text-muted-foreground tabular-nums'>{n}</span>
        <AttributeValueBadge value={n} type={type} compact />
      </div>
    </div>
  );
};

export default AttributeValueEditor;
